<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn id="btn-voltar-form-atendimento" color="primary" x-small text @click="$goBack()">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ titulo }}
        </h1>
      </v-col>
    </v-row>

    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(salvar)" :disabled="somenteLeitura">
        <v-row>
          <v-col class="pt-0 pb-0" cols="12" md="6">
            <ValidationProvider name="Tipo de Atendimento" rules="required" v-slot="{ errors }">
              <e-label>Tipo de Atendimento</e-label>
              <e-autocomplete
                id="select-tipo-de-atendimento"
                :items="tiposDeAtendimento"
                :return-object="false"
                :error-messages="errors"
                v-model="form.tipo_de_atendimento"
                label="Selecione uma opção"
                dense
                solo
                :readonly="somenteLeitura"
              />
            </ValidationProvider>
          </v-col>

          <v-col class="pt-0 pb-0" cols="12" md="6">
            <ValidationProvider name="Bimestre" rules="required" v-slot="{ errors }">
              <e-label>Bimestre</e-label>
              <e-autocomplete
                id="select-bimestre-atendimento"
                :items="bimestres"
                :return-object="false"
                :disabled="!form.tipo_de_atendimento"
                :item-value="(item) => item.valor"
                :item-text="
                  (item) =>
                    item.status === 0 ? item.descricao : `${item.descricao} (Bimestre Bloqueado)`
                "
                :item-disabled="(item) => item.status === 1"
                :error-messages="errors"
                v-model="form.bimestre"
                label="Selecione um bimestre"
                dense
                solo
                :readonly="somenteLeitura"
                @change="aoTrocarBimestre"
              />
            </ValidationProvider>
          </v-col>

          <!--
            Data pelo calendário, limitada ao intervalo do bimestre, como o Diário Online
            faz em Aulas/NewEditAulaPage. Sem isto dá para lançar atendimento em qualquer
            ano.
          -->
          <v-col class="pt-0 pb-0" cols="12" md="6">
            <ValidationProvider name="Data" rules="required" v-slot="{ errors }">
              <e-label>Data</e-label>
              <v-dialog ref="dialogData" v-model="modalData" persistent width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    id="input-data-atendimento"
                    :value="dataFormatada"
                    :error-messages="errors"
                    :disabled="!form.tipo_de_atendimento || !bimestreSelecionado"
                    label="Escolha uma data"
                    :hint="intervaloDoBimestre"
                    persistent-hint
                    readonly
                    v-bind="attrs"
                    v-on="somenteLeitura ? {} : on"
                    dense
                    solo
                  />
                </template>
                <v-date-picker
                  v-model="form.data"
                  :min="bimestreSelecionado ? bimestreSelecionado.data_inicial : undefined"
                  :max="bimestreSelecionado ? bimestreSelecionado.data_final : undefined"
                  scrollable
                >
                  <v-spacer />
                  <v-btn text color="primary" @click="modalData = false">Cancelar</v-btn>
                  <v-btn text color="primary" @click="$refs.dialogData.save(form.data)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </ValidationProvider>
          </v-col>

          <v-col class="pt-0 pb-0" cols="12" md="6">
            <ValidationProvider name="Horário" rules="required" v-slot="{ errors }">
              <e-label>Horário</e-label>
              <e-autocomplete
                id="select-horario-atendimento"
                :items="horarios"
                :return-object="false"
                :item-value="(value) => value.id"
                :item-text="(value) => value.descricao"
                :error-messages="errors"
                v-model="form.horario_id"
                label="Selecione uma opção"
                hint="Somente horários do turno da turma deste vínculo"
                persistent-hint
                dense
                solo
                :readonly="somenteLeitura"
              />
            </ValidationProvider>
          </v-col>

          <v-col cols="12">
            <e-label>Conteúdo</e-label>
            <v-textarea
              id="input-conteudo-atendimento"
              v-model="form.conteudo"
              rows="4"
              solo
              dense
              counter="400"
              maxlength="400"
              :readonly="somenteLeitura"
            />
          </v-col>

          <!--
            Cenário 4 e 5: o sexto campo varia pelo perfil.
            Metodologia para professor e prof-auxiliar; Atividades Realizadas para
            apoio-pedagogico.
          -->
          <v-col cols="12" v-if="usaAtividadesRealizadas">
            <e-label>Atividades Realizadas</e-label>
            <v-textarea
              id="input-atividades-realizadas-atendimento"
              v-model="form.atividades_realizadas"
              rows="4"
              solo
              dense
              counter="400"
              maxlength="400"
              :readonly="somenteLeitura"
            />
          </v-col>
          <v-col cols="12" v-else>
            <e-label>Metodologia</e-label>
            <v-textarea
              id="input-metodologia-atendimento"
              v-model="form.metodologia"
              rows="4"
              solo
              dense
              counter="400"
              maxlength="400"
              :readonly="somenteLeitura"
            />
          </v-col>
        </v-row>

        <v-row v-if="!somenteLeitura">
          <v-col class="d-flex justify-end">
            <v-btn id="btn-salvar-atendimento" color="primary" type="submit" :loading="salvando">
              Salvar
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </ValidationObserver>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    gestaoId: {
      type: [String, Number],
      required: true,
    },
    atendimentoId: {
      type: [String, Number],
      default: null,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    somenteLeitura: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      horarios: [],
      bimestres: [],
      modalData: false,
      salvando: false,
      form: {
        tipo_de_atendimento: null,
        bimestre: null,
        data: null,
        horario_id: null,
        conteudo: null,
        metodologia: null,
        atividades_realizadas: null,
      },
    };
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    titulo() {
      if (this.somenteLeitura) return "Visualizar atendimento";
      return this.editing ? "Editar atendimento" : "Criar novo atendimento";
    },
    // O bimestre escolhido traz data_inicial e data_final, que limitam o calendário.
    bimestreSelecionado() {
      return this.bimestres.find((bimestre) => bimestre.valor === this.form.bimestre) || null;
    },
    intervaloDoBimestre() {
      if (!this.bimestreSelecionado) return "Escolha o bimestre para liberar as datas";
      const { data_inicial: inicio, data_final: fim } = this.bimestreSelecionado;
      return `Datas de ${this.paraBR(inicio)} a ${this.paraBR(fim)}`;
    },
    dataFormatada() {
      return this.paraBR(this.form.data);
    },
    tiposDeAtendimento() {
      return this.$constants.tiposDeAtendimentos;
    },
    usaAtividadesRealizadas() {
      const roleName = this.user && this.user.role ? this.user.role.name : "";
      return roleName === "apoio-pedagogico";
    },
  },
  async mounted() {
    await this.load();
  },
  methods: {
    async load() {
      this.$loaderService.open("Carregando...");
      try {
        this.horarios = await this.$services.atendimentosAuxiliaresService.horarios(this.gestaoId);
        this.bimestres = await this.$services.usuariosService.getBimestresDisponiveis();

        if (this.atendimentoId) {
          const atendimento = await this.$services.atendimentosAuxiliaresService.visualizar(
            this.gestaoId,
            this.atendimentoId
          );
          this.form = {
            tipo_de_atendimento: atendimento.tipo_de_atendimento,
            bimestre: atendimento.bimestre,
            data: atendimento.data,
            horario_id: atendimento.horario_id,
            conteudo: atendimento.conteudo,
            metodologia: atendimento.metodologia,
            atividades_realizadas: atendimento.atividades_realizadas,
          };
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    paraBR(data) {
      if (!data) return "";
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}/${ano}`;
    },
    // A data vale para o bimestre em que foi escolhida; trocar o bimestre a invalida.
    aoTrocarBimestre() {
      this.form.data = null;
    },
    async salvar() {
      this.salvando = true;
      try {
        if (this.editing) {
          await this.$services.atendimentosAuxiliaresService.atualizar(
            this.gestaoId,
            this.atendimentoId,
            this.form
          );
          this.$toast.success("Atendimento atualizado com sucesso");
        } else {
          await this.$services.atendimentosAuxiliaresService.criar(this.gestaoId, this.form);
          this.$toast.success("Atendimento criado com sucesso");
        }
        this.$router.push({
          name: "atendimentosAuxiliares",
          params: { gestaoId: this.gestaoId },
        });
      } catch (error) {
        this.$handleError(error);
      }
      this.salvando = false;
    },
  },
};
</script>
